export const SIZE: number = 20
export const PAGE: number = 0
export const ROWS_OPTIONS: Array<number> = [20, 50, 100]
